/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (this.querySelector('.alert')) {
          // Retour après inscription (ou erreur) : on affiche le message / le code.
          this.open();
        } else if (!getCookie(this.cookie) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.dataset.trigger === 'delay') {
            setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit') {
            this.armExitIntent();
          }
        }
      }

      /**
       * La Bougiterie : intention de sortie sur ordinateur ET sur mobile.
       * - Ordinateur : la souris sort par le haut de la fenêtre.
       * - Mobile : remontée rapide de la page après avoir fait défiler.
       * Jamais avant 8 s sur le site, ni tant que le bandeau cookies est affiché.
       */
      armExitIntent() {
        this.armedAt = Date.now();
        this.maxScroll = 0;
        this.lastY = window.scrollY;
        this.lastT = Date.now();

        this.mouseOutHandler = (evt) => {
          if (evt.clientY <= 0 && !evt.relatedTarget) this.tryExitOpen();
        };
        this.scrollHandler = () => {
          const y = window.scrollY;
          const t = Date.now();
          this.maxScroll = Math.max(this.maxScroll, y);
          const up = this.lastY - y;
          const dt = t - this.lastT;
          if (this.maxScroll > 600 && up > 0 && dt > 0 && dt < 500 && (up / dt) > 1.2) {
            this.tryExitOpen();
          }
          if (dt > 120) {
            this.lastY = y;
            this.lastT = t;
          }
        };

        document.addEventListener('mouseout', this.mouseOutHandler);
        if (!theme.mediaMatches.md) {
          window.addEventListener('scroll', this.scrollHandler, { passive: true });
        }
      }

      cookieBannerVisible() {
        try {
          const cp = window.Shopify && window.Shopify.customerPrivacy;
          if (cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) return true;
        } catch (e) { /* ignore */ }
        const banner = document.getElementById('shopify-pc__banner');
        return !!(banner && banner.offsetParent !== null && getComputedStyle(banner).visibility !== 'hidden');
      }

      tryExitOpen() {
        if (this.exitShown || getCookie(this.cookie)) return;
        if (Date.now() - this.armedAt < 8000) return;
        if (this.cookieBannerVisible()) return;
        this.exitShown = true;
        this.removeExitListeners();
        this.open();
      }

      removeExitListeners() {
        if (this.mouseOutHandler) document.removeEventListener('mouseout', this.mouseOutHandler);
        if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        this.removeExitListeners();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        setCookie(this.cookie, true, parseInt(this.dataset.dismissDays, 10));
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
